var app = angular.module('leonardo');

var WorkFlowItemAddDialog = function (
  $scope,
  $rootScope,
  $window,
  $filter,
  ngDialog,
  TemplateWorkflowService,
  TemplateService,
  AccountUserService,
  AttachmentService,
  FormErrorsService,
  AuthDataService,
  PermissionService,
  UserService,
  WorkFlowService, 
  AccountService,
  TranslationService
) {
  $scope.template = $scope.ngDialogData.template;
  $scope.parent = $scope.ngDialogData.parent;
  $scope.action = $scope.ngDialogData.action;
  $scope.by_unit = $scope.ngDialogData.by_unit;
  $scope.follow_on = $scope.ngDialogData.follow_on;
  $scope.workflow = $scope.ngDialogData.workflow;
  $scope.tabsCollapsed = [];
  $scope.permissionService = PermissionService;
  $scope.accountUserService = AccountUserService;
  $scope.authDataService = AuthDataService;
  $scope.workFlowService = AccountUserService;
  $scope.userService = UserService;
  $scope.currentAccountUser = AccountUserService.currentAccountUser.account;

  $scope.templateService = TemplateService;

  $scope.lagTypes = TemplateService.LAG_TYPES;

  $scope.options = [
    { id: 'days', name: 'Days' },
    { id: 'weeks', name: 'Weeks' },
    { id: 'months', name: 'Months' }
  ];
  $scope.accountObj = null;

  $scope.isNull = isNull;

  $scope.initData = function () {
    if ($scope.template) {
      if ($scope.template.locale && $scope.getLocaleLength($scope.template) > 0) {
        let keys = Object.keys($scope.template.locale);
        if (!keys.includes('en')) {
          $scope.template.locale['en'] = { "body": $scope.template.body , "name": $scope.template.name }
          $scope.localeAdded = true;
        }
      }
      $scope.data = angular.copy($scope.template);
      if (!isNull($scope.data.lag_days)) {
        $scope.data.lag_time_type = 'days';
      }
      if (!isNull($scope.data.lag_weeks)) {
        $scope.data.lag_time_type = 'weeks';
      }
      if (!isNull($scope.data.lag_months)) {
        $scope.data.lag_time_type = 'months';
      }
      $scope.data.creator = $scope.data.creator.id;

      $scope.data.budget = parseFloat($scope.data.budget);
      $scope.data.approval_steps = $filter('orderBy')($scope.data.approval_steps, 'index');
      $scope.data.account_users_assigned = $scope.initUsers($scope.data.account_users_assigned);
      $scope.data.notify_at_approval_complete_users = $scope.initUsers($scope.data.notify_at_approval_complete_users);
      $scope.data.notify_at_approval_terminated_users = $scope.initUsers($scope.data.notify_at_approval_terminated_users);
      $scope.data.enabled = $scope.template.status == TemplateService.STATUS_PUBLISHED;
      $scope.data.mimo_task = !!$scope.template.mimo_task;
      $scope.data.resident_inspection = !!$scope.template.resident_inspection;
      $scope.data.attachments = [];
      $scope.data.languages = ($scope.template.languages && $scope.template.languages.length > 0) ? $scope.template.languages.map(lang => lang.id) : ['2'],
      $scope.data.translation = ($scope.template.languages && $scope.template.languages.length > 0) ? true : false,
      $scope.data.created_in_language = $scope.template.created_in_language ? $scope.template.created_in_language : 'en',
      $scope.data.updated_in_language = $scope.template.updated_in_language ? $scope.template.updated_in_language : 'en',
      $scope.data.locale = $scope.template.locale,
      $scope.data.role_based = {
        roles: !isEmpty($scope.template.roles) ? $scope.template.roles.map(function (obj) { return obj.id || obj; }) : [],
        role_based_only: !isNull($scope.template.role_based_only) ? $scope.template.role_based_only : false
      };

      if ($scope.data.levels.length > 0) {
        var levels = [];
        angular.forEach($scope.data.levels, function (level) {
          levels.push(level.id);
        });
        $scope.data.levels = levels;
      } else {
        delete $scope.data.levels;
      }

      if ($scope.data.managed_by) {
        $scope.data.managed_by = $scope.data.managed_by.id ? $scope.data.managed_by.id : $scope.data.managed_by;
      }

      if ($scope.template.attachments && $scope.template.attachments.length > 0) {
        var filters = {
          disable_pagination: true,
          id: $scope.template.attachments.join(',')
        };
        $scope.data.attachments = AttachmentService.getlist(filters).$object;
      }
    } else {
      var roles = [];
      if (!isNull($scope.parent)) {
        roles = (!isEmpty($scope.parent.roles) ? $scope.parent.roles.map(function (obj) { return obj.id || obj; }) : [])
      }
      else {
        roles = (!isNull($scope.workflow) && !isEmpty($scope.workflow.roles) ? $scope.workflow.roles.map(function (obj) { return obj.id || obj; }) : [])
      }
      var role_based_only = null;
      if (!isNull($scope.parent)) {
        role_based_only = $scope.parent.role_based_only;
      }
      else {
        role_based_only = (!isNull($scope.workflow) ? $scope.workflow.role_based_only : false);
      }
      var account = null;
      if (!isNull($scope.parent)) {
        account = $scope.parent.account;
      }
      else {
        account = (!isNull($scope.workflow) ? $scope.workflow.account : AccountUserService.currentAccountUser.account);
      }
      $scope.data = {
        type: TemplateService.TYPE_ACCOUNT_WORKFLOW,
        account: account,
        enabled: true,
        mimo_task: false,
        resident_inspection: false,
        fields: {},
        notify_to: [],
        contact_types: [],
        role_based: {
          roles: roles,
          role_based_only: role_based_only
        },
        languages: ['2'],
        created_in_language: 'en',
        updated_in_language : 'en'
      };
    }

    if (AuthDataService.isNotStaff()) {
      $scope.filtersAccountUsers = { disable_pagination: true, active: true, essential: true, user_is_active: true };
      AccountUserService.getAvailableToAssign($scope.filtersAccountUsers).then(function (data) {
        $scope.usersAccount = data.results;
      });
    } else {
      $scope.data.type = TemplateService.TYPE_SYSTEM_WORKFLOW;
    }

    if ($scope.follow_on) {
      $scope.data.follow_on = $scope.follow_on;
    }

    if ($scope.data.follow_on && $scope.data.lag_type === undefined) {
      $scope.data.lag_type = TemplateService.TYPE_LAG_FS;
    }

    if ($scope.workflow && !$scope.data.workflow) {
      $scope.data.workflow = $scope.workflow.id ? $scope.workflow.id : $scope.workflow;
    }

    $scope.accountUser = AccountUserService.getAccountUser($scope.data.account);
    AccountService.get($scope.currentAccountUser).then(function (data) {
      $scope.accountObj = data;
    }).catch(function () {
      $scope.accountObj = null;
    });
  };

  $scope.initUsersRole = function (users) {
    var userIds = [];
    if (!isEmpty(users)) {
      angular.forEach(users, function (user) {
        if ($scope.usersAccount) {
          if ($scope.usersAccount.find((item) => item.id == user)) {
            userIds.push($scope.usersAccount.find((item) => item.id == user));
          }
        } else {
          userIds.push(user);
        }
      });
    }
    return userIds;
  };

  $scope.validationRole = function () {
    var valid = true;
    var account_users_assigned = angular.copy($scope.data.account_users_assigned);
    if (angular.isString(account_users_assigned)) {
      account_users_assigned = account_users_assigned.split(',');
    }
    var users_assigned = $scope.initUsersRole(account_users_assigned);
    if (!isEmpty(users_assigned) && !isEmpty($scope.data.role_based) && !isEmpty($scope.data.role_based.roles)) {
      angular.forEach(users_assigned, function (user) {
        if (!$scope.data.role_based.roles.find((item) => item === user.role)) {
          valid = false;
        }
      });
    }
    return valid;
  }

  $scope.roleValidation = {
    error: 'userRole',
    message: $filter('translate')('The user role of the individual(s) selected to automatically assign to the task should match at least one role selected in Role-based section'),
    validation: $scope.validationRole,
    eventWatch: 'users_roles:updated'
  }

  $scope.showMIMO = function () {
    let unit_turn_type = !isNull($scope.workflow.unit_turn_type) ? $scope.workflow.unit_turn_type.toString() : null;
    return $scope.workflow.is_unit_turn && [WorkFlowService.WORFLOW_MOVE_IN, WorkFlowService.WORFLOW_MOVE_OUT].includes(unit_turn_type);
  };

  $scope.updateLagTime = function () {
    switch ($scope.data.lag_time_type) {
      case 'days':
        $scope.data.lag_months = null;
        $scope.data.lag_weeks = null;
        break;
      case 'weeks':
        $scope.data.lag_months = null;
        $scope.data.lag_days = null;
        break;
      case 'months':
        $scope.data.lag_weeks = null;
        $scope.data.lag_days = null;
        break;
    }
  };

  $scope.initUsers = function (users) {
    var userIds = [];
    angular.forEach(users, function (user) {
      if (user.id) {
        userIds.push(user.id);
      } else {
        userIds.push(user);
      }
    });
    return userIds;
  };

  $scope.getNumber = function (num) {
    return new Array(num);
  };

  $scope.toggleTab = function (tab) {
    if ($scope.tabHidden(tab)) {
      $scope.tabsCollapsed.splice($scope.tabsCollapsed.indexOf(tab), 1);
    } else {
      $scope.tabsCollapsed.push(tab);
    }
  };

  $scope.tabHidden = function (tab) {
    return _.contains($scope.tabsCollapsed, tab);
  };

  $scope.groupVisible = function (group) {
    var anyVisible = false;

    angular.forEach(group.subgroups, function (subgroup) {
      if (subgroup.data['template_widget'] !== 'hidden') anyVisible = true;
    });
    return anyVisible;
  };

  $scope.getLagType = function () {
    if ($scope.data && !isNull($scope.data.lag_type)) {
      if ($scope.data.lag_type == TemplateService.TYPE_LAG_FS) {
        $scope.data.start_when_finish = true;
      }
    }
  };

  $scope.getNameAccount = function (account) {
    var array_account = [];
    if (account) {
      array_account = angular.isArray(account) ? account : account.split(',');
    }
    var labels = [];
    angular.forEach(array_account, function (account_id) {
      if (AuthDataService.authData.account) {
        angular.forEach(AuthDataService.authData.account.managed_to_me, function (managed) {
          if (managed.id == account_id) {
            labels.push(managed.name);
          }
        });
      }
    });
    return labels.join(',');
  };

  $scope.removeAttachment = function (index) {
    $scope.data.attachments.splice(index, 1);
  };

  $scope.showAttachment = function (index) {
    if ($scope.data.attachments[index].document_file) {
      // Use signed_view_url for secure inline viewing
      $window.open($scope.data.attachments[index].document_file.signed_view_url || $scope.data.attachments[index].document_file.secure_share_url || $scope.data.attachments[index].document_file.file);
    } else if ($scope.data.attachments[index].link) {
      $window.open($scope.data.attachments[index].link);
    } else {
      if (angular.isObject($scope.data.attachments[index].file)) {
        var reader = new FileReader();
        reader.addEventListener(
          'load',
          function () {
            ngDialog.open({
              template: 'views/templates/dialog/show-image.html',
              className: 'ngdialog-theme-default ngdialog-attachments-view',
              data: {
                name: $scope.data.attachments[index].name,
                src: reader.result
              }
            });
          },
          false
        );
        reader.readAsDataURL($scope.data.attachments[index].file);
      } else {
        // Use signed_view_url for secure inline viewing
        $window.open($scope.data.attachments[index].signed_view_url || $scope.data.attachments[index].secure_share_url || $scope.data.attachments[index].file);
      }
    }
  };

  $scope.showAttachDialog = function () {
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/attachment/upload.html',
        controller: 'AttachmentUploadDialog',
        data: { task: $scope.data, mode: 'upload', showManagement: true }
      })
      .then(function (attachments) {
        $scope.data.attachments = [];
        angular.forEach(attachments, function (attachment) {
          $scope.data.attachments.push(attachment);
        });
      }, function () {
        return;
      });
  };

  $scope.getApprovalName = function (user) {
    return $filter('username')(user) + ' - ' + user.email;
  };

  $scope.sortApprovalsSteps = function () {
    angular.forEach($scope.data.approval_steps, function (step, index) {
      step.index = index + 1;
    });
  };

  $scope.showAddApprovalDialog = function () {
    if (isNull($scope.data.approval_steps)) {
      $scope.data.approval_steps = [];
    }
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/template/approval.html',
        controller: 'ApprovalDialog',
        className: 'ngdialog-theme-default ngdialog-approvals',
        data: {
          template: $scope.data,
          data: { index: $scope.data.approval_steps.length + 1 },
          action: 'create'
        }
      })
      .then(function (result) {
        if (result.index === $scope.data.approval_steps.length + 1) {
          $scope.data.approval_steps.push(result);
        } else {
          $scope.data.approval_steps.splice(result.index - 1, 0, result);
          $scope.sortApprovalsSteps();
        }
      }, function () {
        return;
      });
  };

  $scope.showEditApprovalDialog = function (index) {
    const approval = angular.copy($scope.data.approval_steps[index]);
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/template/approval.html',
        controller: 'ApprovalDialog',
        className: 'ngdialog-theme-default ngdialog-approvals',
        data: {
          template: $scope.data,
          data: approval,
          action: 'edit'
        }
      })
      .then(function (result) {
        if (index === result.index - 1) {
          $scope.data.approval_steps[index] = result;
        } else {
          $scope.data.approval_steps.splice(index, 1);
          $scope.data.approval_steps.splice(result.index - 1, 0, result);
          $scope.sortApprovalsSteps();
        }
      }, function () {
        return;
      });
  };

  $scope.deleteApproval = function (index) {
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/template/delete-approval.html',
        controller: 'DeleteApprovalStepDialog',
        data: {
          object: $scope.data.approval_steps[index]
        }
      })
      .then(function () {
        $scope.data.approval_steps.splice(index, 1);
        angular.forEach($scope.data.approval_steps, function (approval, indexNew) {
          if (indexNew >= index) {
            approval.index--;
          }
        });
      }, function () {
        return;
      });
  };

  $scope.submit = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.getLagType();
    var attachments = angular.copy($scope.data.attachments);
    $scope.data.attachments = [];
    angular.forEach(attachments, function (attachment) {
      $scope.data.attachments.push(attachment.id);
    });
    var account_users_assigned = angular.copy($scope.data.account_users_assigned);
    if (angular.isString(account_users_assigned)) {
      account_users_assigned = account_users_assigned.split(',');
    }
    $scope.data.account_users_assigned = $scope.initUsers(account_users_assigned);
    $scope.data.notify_at_approval_complete_users = $scope.initUsers($scope.data.notify_at_approval_complete_users);
    $scope.data.notify_at_approval_terminated_users = $scope.initUsers($scope.data.notify_at_approval_terminated_users);
    var data = angular.copy($scope.data);
    data['status'] = $scope.data.enabled ? TemplateService.STATUS_PUBLISHED : TemplateService.STATUS_UNPUBLISHED;
    delete data.enabled;
    delete data.lag_time_type;

    delete data.role_based;
    if ($scope.data.role_based) {
      data['roles'] = $scope.data.role_based.roles;
      data['role_based_only'] = $scope.data.role_based.role_based_only;
    }

    if ($scope.data.approval_steps) {
      angular.forEach($scope.data.approval_steps, function (approval, index) {
        data['approval_steps'][index]['user_approvers'] = !isEmpty(approval.user_approvers)
          ? approval.user_approvers.map((item) => parseInt(item.id || item))
          : [];
        data['approval_steps'][index]['user_role_approvers'] = !isEmpty(approval.user_role_approvers)
          ? approval.user_role_approvers.map((item) => parseInt(item.id || item))
          : [];
        data['approval_steps'][index]['secondary_user_approvers'] = !isEmpty(approval.secondary_user_approvers)
          ? approval.secondary_user_approvers.map((item) => parseInt(item.id || item))
          : [];
          data['approval_steps'][index]['secondary_user_role_approvers'] = !isEmpty(approval.secondary_user_role_approvers)
          ? approval.secondary_user_role_approvers.map((item) => parseInt(item.id || item))
          : [];
      });
    }
    
    if($scope.data.languages){
      $scope.data.languages = angular.isArray($scope.data.languages) ? $scope.data.languages : $scope.data.languages.split(',');
    }
    // need to manage the languages when translation is off then language should be blank array
    if($scope.data.translation && $scope.data.languages && $scope.data.languages.length > 0){
      data.languages = $scope.data.languages.map(Number);
    }
    else {
      data.languages = [];
      delete data['created_in_language'];
      delete data['updated_in_language'];
    }
    if($scope.localeAdded){
      delete data.locale['en'];
    }
    delete data['translation'];

    if ($scope.action === 'create') {
      TemplateWorkflowService.post(data).then(function (result) {
        if ($scope.workflow) {
          var templates = [];
          angular.forEach($scope.workflow.templates, function (template) {
            templates.push(template.id);
          });
          templates.push(result.id);
          $scope.workflow.patch({ templates: templates }).then(function () {
            $scope.confirm(result);
          });
        } else {
          $scope.confirm(result);
        }
      });
    } else {
      $scope.template.patch(data).then(function (result) {
        $scope.confirm(result);
      });
    }
  };

  $scope.changeSelectedTab = function (lang){
     $scope.data.updated_in_language = lang;
  }

  $scope.getLocaleLength = function(template){
    let keys = Object.keys(template.locale);
    return keys.length;
  }

  $scope.updateTranslations = function (field_name){
    if($scope.template.locale && Object.keys($scope.template.locale).length > 0 && ($scope.data.created_in_language == $scope.data.updated_in_language)){
      let translate_lang = Object.keys($scope.template.locale).filter(key => (key != $scope.data.updated_in_language));
      let context = {id: field_name, value:  $scope.template.locale[$scope.data.updated_in_language][field_name]}
      let request = {
        original_lang: $scope.data.updated_in_language,
        translate_lang: (translate_lang && translate_lang.length > 0) ? translate_lang : ['en'],
        context: context
      }
      TranslationService.post(request).then(function (result) {
        if (result && result.context && result.context.length > 0) {
          result.context.forEach(translated_data => {
            translated_data.forEach(loc => {
              Object.keys(loc).forEach(lang_code => {
                $scope.data.locale[lang_code][field_name] = loc[lang_code]['value'];
              })
            })
          })
          $scope.data[field_name] = $scope.data.locale['en'][field_name];
        }
      })
    }
  }

  $scope.initData();

  $scope.$watch('data.role_based.roles', function (newValue,oldValue) {
    if (!angular.equals(newValue, oldValue)) {
      $rootScope.$broadcast('users_roles:updated');
    }
  });
};

app.controller('WorkFlowItemAddDialog', [
  '$scope',
  '$rootScope',
  '$window',
  '$filter',
  'ngDialog',
  'TemplateWorkflowService',
  'TemplateService',
  'AccountUserService',
  'AttachmentService',
  'FormErrorsService',
  'AuthDataService',
  'PermissionService',
  'UserService',
  'WorkFlowService',
  'AccountService',
  'TranslationService',
  WorkFlowItemAddDialog
]);
